export type UiComponentKey =
  | "Button"
  | "Input"
  | "Select"
  | "Checkbox"
  | "Switch"
  | "Form"
  | "FormPro"
  | "DatePicker"
  | "DateRangePicker"
  | "DateTimePicker"
  | "DateTimeRangePicker"
  | "Dialog"
  | "AlertDialog"
  | "Drawer"
  | "ConfirmDialog"
  | "DropdownMenu"
  | "Toast"
  | "Tabs"
  | "Breadcrumb"
  | "Pagination"
  | "Tree"
  | "Upload"
  | "CosUpload"
  | "DataTable"
  | "Table"
  | "Descriptions"
  | "Badge"
  | "Skeleton"
  | "Separator";

export interface UiLibraryComponent {
  value: UiComponentKey;
  slug: string;
  label: string;
  description: string;
  section: UiLibrarySection;
}

export type UiLibrarySection = "base" | "business";

export const uiLibrarySections = [
  { value: "base", label: "基础组件库" },
  { value: "business", label: "业务组件库" },
] satisfies Array<{ value: UiLibrarySection; label: string }>;

export const uiLibraryComponents: UiLibraryComponent[] = [
  {
    value: "Button",
    slug: "button",
    label: "Button",
    description: "按钮状态、尺寸和图标组合",
    section: "base",
  },
  { value: "Input", slug: "input", label: "Input", description: "基础文本输入", section: "base" },
  { value: "Select", slug: "select", label: "Select", description: "下拉选择器", section: "base" },
  {
    value: "Checkbox",
    slug: "checkbox",
    label: "Checkbox",
    description: "复选框与半选状态",
    section: "base",
  },
  { value: "Switch", slug: "switch", label: "Switch", description: "二元开关", section: "base" },
  {
    value: "Form",
    slug: "form",
    label: "Form",
    description: "TanStack Form 基础层",
    section: "base",
  },
  {
    value: "FormPro",
    slug: "form-pro",
    label: "FormPro",
    description: "后台 CRUD 表单布局",
    section: "base",
  },
  {
    value: "DatePicker",
    slug: "date-picker",
    label: "DatePicker",
    description: "单日期选择",
    section: "base",
  },
  {
    value: "DateRangePicker",
    slug: "date-range-picker",
    label: "DateRangePicker",
    description: "日期区间选择",
    section: "base",
  },
  {
    value: "DateTimePicker",
    slug: "date-time-picker",
    label: "DateTimePicker",
    description: "日期时间选择",
    section: "base",
  },
  {
    value: "DateTimeRangePicker",
    slug: "date-time-range-picker",
    label: "DateTimeRangePicker",
    description: "日期时间区间选择",
    section: "base",
  },
  {
    value: "Dialog",
    slug: "dialog",
    label: "Dialog",
    description: "普通弹窗和滚动弹窗",
    section: "base",
  },
  {
    value: "AlertDialog",
    slug: "alert-dialog",
    label: "AlertDialog",
    description: "需要明确决策的警示弹窗",
    section: "base",
  },
  {
    value: "Drawer",
    slug: "drawer",
    label: "Drawer",
    description: "抽屉式补充面板",
    section: "base",
  },
  {
    value: "ConfirmDialog",
    slug: "confirm-dialog",
    label: "ConfirmDialog",
    description: "项目二次确认封装",
    section: "base",
  },
  {
    value: "DropdownMenu",
    slug: "dropdown-menu",
    label: "DropdownMenu",
    description: "菜单、子菜单和选择项",
    section: "base",
  },
  { value: "Toast", slug: "toast", label: "Toast", description: "全局消息反馈", section: "base" },
  { value: "Tabs", slug: "tabs", label: "Tabs", description: "同级内容切换", section: "base" },
  {
    value: "Breadcrumb",
    slug: "breadcrumb",
    label: "Breadcrumb",
    description: "路径导航",
    section: "base",
  },
  {
    value: "Pagination",
    slug: "pagination",
    label: "Pagination",
    description: "分页导航",
    section: "base",
  },
  {
    value: "Tree",
    slug: "tree",
    label: "Tree",
    description: "树形展示、复选和操作区",
    section: "base",
  },
  {
    value: "Upload",
    slug: "upload",
    label: "Upload",
    description: "文件选择、校验和上传状态",
    section: "base",
  },
  {
    value: "CosUpload",
    slug: "cos-upload",
    label: "CosUpload",
    description: "腾讯云 COS 业务上传",
    section: "business",
  },
  {
    value: "DataTable",
    slug: "data-table",
    label: "DataTable",
    description: "搜索、工具栏、表格和分页",
    section: "base",
  },
  { value: "Table", slug: "table", label: "Table", description: "基础表格结构", section: "base" },
  {
    value: "Descriptions",
    slug: "descriptions",
    label: "Descriptions",
    description: "结构化详情信息展示",
    section: "base",
  },
  { value: "Badge", slug: "badge", label: "Badge", description: "状态徽标", section: "base" },
  {
    value: "Skeleton",
    slug: "skeleton",
    label: "Skeleton",
    description: "加载占位",
    section: "base",
  },
  {
    value: "Separator",
    slug: "separator",
    label: "Separator",
    description: "内容分隔线",
    section: "base",
  },
];

export function getUiLibraryComponents(section: UiLibrarySection) {
  return uiLibraryComponents.filter((component) => component.section === section);
}
